// extracted by mini-css-extract-plugin
module.exports = {"photoPost":"UserPhotoPost_photoPost__2MTOK","file":"UserPhotoPost_file__woRxA","preview":"UserPhotoPost_preview__3Rxtv"};